import React, { useEffect, useState } from 'react';
import Apiservice from '../Apiservice';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { formatDate, formatDateForInput, getCurrentDate } from '../Utils/Utils';

const EOccurrence = () => {
  const [loggedRoleId, setLoggedRoleId] = useState(0);
  const [loggedUserId, setLoggedUserId] = useState(0);
  const [currentDate, setCurrentDate] = useState('');

  const navigate = useNavigate();
  const [sites, setSites] = useState([]);
  const [presentStaffs, setPresentStaffs] = useState([])
  const [occurrences, setOccurrences] = useState([]);

  const [selectedSiteId, setSelectedSiteId] = useState(() => {
    if (loggedRoleId === 1) return 0; // admin default 0, must select
    return Number(localStorage.getItem("siteId")) || 0; // normal user
  });

  const loggedUserType = localStorage.getItem('userType');

  const [selectedSite, setSelectedSite] = useState([]);
  const [updateId, setUpdateId] = useState(null); // ID of occurrence being updated
  const [formData, setFormData] = useState({
    siteId: 0,
    date: '',
    time: '',
    user: 0,
    subject: '',
    occurrence: ''
  });

  const [filteredStaffs, setFilteredStaffs] = useState([]);

  useEffect(() => {
    const userId = localStorage.getItem('user_id');
    const roleId = localStorage.getItem('role_id');
    setLoggedUserId(userId);
    setLoggedRoleId(Number(roleId));
  }, []);

  useEffect(() => {
    setPresentStaffs(selectedSite?.presentStaffs || []);
  }, [selectedSiteId, selectedSite]);

  useEffect(() => {
    setCurrentDate(getCurrentDate());
  }, []);


  useEffect(() => {
    if (!currentDate) return;   // ⛔ prevent running until date is ready
    fetchData();
  }, [loggedRoleId, selectedSiteId, currentDate]);



  const fetchData = async () => {
    let data = {
      "siteId": selectedSiteId,
      "date": currentDate,
      "status": 0
    };
    let result = await Apiservice.OccurrenceListPage(data);
    console.log("data", data);
    if (result.success === true && result.data.enrichedOccurrences) {
      setOccurrences(result.data.enrichedOccurrences);
      setSites(result.data.sites);
    } else if (result.success === true && !result.data.enrichedOccurrences) {
      setOccurrences([]);
      setSites(result.data.sites);
    }
    else {
      setOccurrences([]);
      setSites([])
    }
  };

  const handleAdd = () => {
    if (!selectedSite || (Array.isArray(selectedSite) && selectedSite.length === 0)) {
      Swal.fire({
        title: "⚠️ No Site Selected",
        text: "Please select a site before proceeding.",
        icon: "warning",
        confirmButtonText: "Okay",
        confirmButtonColor: "#8350C2", // match your theme color
        background: "#f9f9ff", // soft background
        color: "#333", // text color
      });
      return;
    }

    navigate('/eoccurrenceadd', { state: { site: selectedSite } });
  };

  const handleDelete = async (occurrenceId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        let result = await Apiservice.OccurrenceSoftDelete({ occurrenceId, status: 0 });
        if (result.success === true) {
          Swal.fire('Deleted!', 'Occurrence deleted successfully.', 'success');
          fetchData();
        } else {
          Swal.fire('Error!', 'Could not delete occurrence.', 'error');
        }
      }
    });
  };

  const handleEdit = (occurrence) => {
    setUpdateId(occurrence.id);
    if (occurrence.userId > 1) {
      setFormData({
        siteId: occurrence.siteId,
        date: formatDateForInput(occurrence.date),
        time: occurrence.time,
        user: occurrence.userDetails[0].id,
        subject: occurrence.subject,
        occurrence: occurrence.occurrence
      });
    } else {
      setFormData({
        siteId: occurrence.siteId,
        date: formatDateForInput(occurrence.date),
        time: occurrence.time,
        user: "",
        subject: occurrence.subject,
        occurrence: occurrence.occurrence
      });
    }

  };


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getSelectedDateTime = () => {
    if (!formData.date || !formData.time) return null;
    return new Date(`${formData.date}T${formData.time}`);
  };


  // const getSelectedDateTime = () => {
  //   if (!formData.date || !formData.time) return null;
  //   return new Date(`${formData.date}T${formData.time}:00Z`);
  // };


  // useEffect(() => {
  //   const filteredStaffs = presentStaffs.filter((staff) => {
  //     const entry = new Date(staff.entryTime);
  //     const exit = staff.exitTime ? new Date(staff.exitTime) : null;
  //     const selected = getSelectedDateTime();

  //     if (!selected) return false;

  //     return selected >= entry && (!exit || selected <= exit);
  //   });

  //   setFilteredStaffs(filteredStaffs);
  // }, [updateId]);
  // console.log("update",updateId)

  useEffect(() => {
    const filtered = presentStaffs.filter((staff) => {
      const entry = new Date(staff.entryTime);
      const exit = staff.exitTime ? new Date(staff.exitTime) : null;
      const selected = getSelectedDateTime();
      if (!selected) return false;
      return selected >= entry && (!exit || selected <= exit);
    });

    setFilteredStaffs(filtered);
  }, [updateId, formData, presentStaffs]); // include formData so changes to date/time trigger it

  //   useEffect(() => {
  //     const fetchData = async () => {
  // let result = await Apiservice.floa
  //     };
  //     fetchData();
  //   })


  const handleSave = async (occurrenceUserId) => {
    let dataToSend = {};
    if (occurrenceUserId > 1) {
      dataToSend = {
        occurrenceId: updateId,
        status: 0,
        userId: formData.user,
        ...formData
      };
    } else {
      dataToSend = {
        occurrenceId: updateId,
        status: 0,
        userId: 0,
        ...formData
      };
    }

    let result = await Apiservice.OccurrenceUpdate(dataToSend);
    if (result.success) {
      Swal.fire('Updated!', 'Occurrence updated successfully.', 'success');
      setUpdateId(null);
      fetchData();
    } else {
      // Swal.fire('Error!', 'Could not update occurrence.', 'error');
      Swal.fire(result.message);
    }
  };

  return (
    <div className="container-fluid shadow p-2">
      <div className="row mb-2">
        <div className="col text-center">
          <h3>E-Occurrence</h3>
        </div>
      </div>


      {/* Sites Info */}
      {
        loggedRoleId == 1 && (
          <>
          <div className="row">
  {sites.map((site) => (
    <div
      key={site.id}
      className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3"
    >
      <div
        className={`card shadow-sm h-100 p-3 site-card 
          ${selectedSiteId === site.id 
            ? 'bg-primary text-white border-primary' 
            : 'bg-light'
          }`}
        onClick={() => {
          setSelectedSiteId(site.id);
          setSelectedSite(site);
        }}
        style={{ cursor: "pointer" }}
      >
        <h6 className="mb-1 fw-bold">{site.name}</h6>
        <p className="mb-1 small">{site.mobileNo}</p>
        <p className="mb-0 small text-break">{site.emailId}</p>
      </div>
    </div>
  ))}
</div>

          </>
        )
      }

      <div className="row">

        {
          loggedRoleId === 1 && (
            <div className="row mb-2 ">
              <div className="col text-end">
                <button className="btn btn-sm btn-primary" onClick={handleAdd}>
                  Add
                </button>
              </div>
            </div>
          )
        }


        {/* Occurrences Table */}
        <div className="row">
          <div className="col table">
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className='table-dark'>
                  <tr>
                    <th style={{ width: "5%" }}>#</th>
                    {/* {
                        selectedSiteId === 0 && (
                          <th>Site</th>
                        )
                      } */}

                    <th style={{ width: "10%" }}>Date</th>
                    <th style={{ width: "10%" }}>Time</th>
                    <th style={{ width: "10%" }}>Staff</th>
                    <th style={{ width: "10%" }}>Nric Or Fin</th>
                    <th>Subject</th>
                    <th>Occurrences</th>
                    {
                      loggedRoleId == 1 && (
                        <th>Action</th>
                      )
                    }

                  </tr>
                </thead>
                <tbody>
                  {occurrences.length > 0 ? (
                    occurrences.map((occ, index) => (
                      <tr key={occ.id}>
                        <td style={{ width: "5%" }}>{index + 1}</td>
                        {/* {
                            selectedSiteId === 0 && (
                              <td>{occ.siteId}</td>
                            )
                          } */}

                        {updateId === occ.id ? (

                          <>
                            <td style={{ width: "10%" }}>
                              <input
                                type="date"
                                name="date"
                                value={formData.date}
                                onChange={handleChange}
                                className="form-control form-control-sm"
                              />
                            </td>
                            <td style={{ width: "10%" }}>
                              <input
                                type="time"
                                name="time"
                                value={formData.time}
                                onChange={handleChange}
                                className="form-control form-control-sm"
                              />
                            </td>
                            <td style={{ width: "10%" }}>
                              {
                                occ.userId > 1 && (
                                  <select
                                    name="user"
                                    value={formData.user}
                                    onChange={handleChange}
                                    className="form-control form-control-sm"
                                  >
                                    {filteredStaffs.length > 0 ? (
                                      filteredStaffs.map((staff) => (
                                        <option value={staff.user_id} key={staff.user_id}>
                                          {staff.userDetails
                                            ? `${staff.userDetails.firstName} ${staff.userDetails.lastName}`
                                            : "Unknown"}
                                        </option>
                                      ))
                                    ) : (
                                      <option value="">No Staffs Available</option>
                                    )}
                                  </select>
                                )
                              }

                            </td>
                            <td>{occ.nricOrFin}</td>

                            <td>
                              <input
                                type="text"
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                className="form-control form-control-sm"
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                name="occurrence"
                                value={formData.occurrence}
                                onChange={handleChange}
                                className="form-control form-control-sm"
                              />
                            </td>
                            <td className='text-center'>
                              <button className="btn btn-sm btn-success m-2" onClick={() => handleSave(occ.userId)}>
                                Save
                              </button>
                              <button
                                className="btn btn-sm btn-secondary"
                                onClick={() => setUpdateId(null)}
                              >
                                Cancel
                              </button>
                            </td>
                          </>
                        ) : (
                          <>
                            <td style={{ width: "10%" }}>{formatDate(occ.date)}</td>
                            <td style={{ width: "10%" }}>{occ.time || '-'}</td>
                            <td style={{ width: "10%" }}>
                              {occ.userDetails?.[0]
                                ? `${occ.userDetails[0].firstName || ''} ${occ.userDetails[0].lastName || ''}`
                                : '-'}
                            </td>
                            <td>{occ.nricOrFin || '-'}</td>
                            <td>{occ.subject || '-'}</td>
                            <td>{occ.occurrence || '-'}</td>

                            {
                              loggedRoleId == 1 && (
                                <>
                                  <td className='text-center'>
                                    <button
                                      className="btn btn-sm btn-primary m-2"
                                      onClick={() => handleEdit(occ)}
                                    >
                                      Update
                                    </button>
                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={() => handleDelete(occ.id)}
                                    >
                                      Delete
                                    </button>
                                  </td>
                                </>
                              )
                            }

                          </>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={8} style={{ textAlign: 'center' }}>
                        No data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>



      {/* Hover CSS for site cards */}
      <style>{`
        .site-card:hover {
          transform: scale(1.03);
          transition: 0.2s;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }
      `}</style>
    </div>
  );
};

export default EOccurrence;
